import { RQ, isIOS } from 'utils';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getList: async function (page) {//普通会员
    const res = await RQ.mall.get('/api/h5/coupon/listCoupon', { page, pageSize: 20, couponType: 1, roleType: 1 });
    return res;
  },
  onChangedList: function (data) {
    this.list = data;
  },
  getList1: async function (page) {//超级会员
    const res = await RQ.mall.get('/api/h5/coupon/listCoupon', { page, pageSize: 20, couponType: 1, roleType: 2 });
    return res;
  },
  onChangedList1: function (data) {
    this.list1 = data;
  },
  receiveCoupon: async function (coupon) {//领取普通优惠券
    var self = this;
    const d = await RQ.mall.post('/api/h5/coupon/receiveCoupon', { couponId: coupon, position: 3 });

    if (d && d.code == 0) {
      setTimeout(function () {
        if (d.data.receiveStatus == 1) {//领取状态（0：可以领取，1：已达领取上限）
          self.list.items.filter(item => {
            if (item.couponId == coupon) {
              return item.receiveStatus = 1;
            }
          });
        }
        self.tips(d.msg);
      }, 500);

    } else {
      self.tips(d.msg);
    }
  },
  receiveCoupon1: async function (coupon) {//领取超级会员优惠券
    var self = this;
    const d = await RQ.mall.post('/api/h5/coupon/receiveCoupon', { couponId: coupon, position: 3 });

    if (d && d.code == 0) {
      setTimeout(function () {
        if (d.data.receiveStatus == 1) {//领取状态（0：可以领取，1：已达领取上限）
          self.list1.items.filter(item => {
            if (item.couponId == coupon) {
              return item.remain = 0;
            }
          });
        }
        self.tips(d.msg);
      }, 500);

    } else if (d.code == -3) {//未开通超级会员
      this.showMn = true;
    } else {
      self.tips(d.msg);
    }
  },
  cancel: function () {
    let self = this;
    self.popupVisible1 = false;
  },
  downLoadApp: async function () {
    addClickAnalytics({ LogTitle: '下载APP使用优惠券' });
    this.$router.push({ path: `/download?enterprise=${this.enterprise}` });
  },
  confirmFn() {
    if (this.isWeChat) {
      // 立即开通
      this.$router.push('/vippay?enterprise=' + this.enterprise);
    } else {
      // 下载app
      this.downLoadApp();
    }
  },
  cancelFn() {
    let self = this;
    self.showMn = false;
  },
  getMemberInfo: async function () {
    const res = await RQ.mall.get('/api/app/member/getMemberSet', {
      cache: 'local',
      cacheTime: 15 * 60 * 1000,
      skipAuthHandle: true
    });

    if (res && res.code == 0) {
      this.MemberInfo = res.data;
      this.tabs[0] = '普通会员券';
      this.tabs[1] = this.MemberInfo.memberName + '券';
    } else {
      this.tips(res.msg, 1500);
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/coupon/action.js